export default [
  { value: 'Subscriber-Unsubscription', label: 'Subscriber Unsubscription' },
  { value: 'Subscriber-DonationSuccess', label: 'Donation Success' },
  { value: 'paidLinkSuccess', label: 'Paid Link Success' },
  { value: 'Subscriber-Paid-Subscription-Cancelled', label: 'Paid Subscription Cancelled' },
  { value: 'Subscriber-Paid-Subscription-Success', label: 'Paid Subscription Success' },
  { value: 'Subscriber-Recurrency-Payment-Paid', label: 'Subscriber Recurrency Payment Paid' },
  { value: 'Subscriber-Subscription', label: 'Subscriber Subscription' },
  { value: 'Subscriber-Refund-Success', label: 'Subscriber Refund Success' },
  { value: 'Subscriber-Two-Verification-Subscription', label: 'Subscriber Two Verification' },
  { value: 'Short-Notification-Reply', label: 'Short Notification Reply' },
  { value: 'Short-resume', label: 'Short Resume' },
  { value: 'Publisher-BulkSubscriptio', label: 'Publisher Bulk Subscription' },
  { value: 'Publisher-DonationSuccess', label: 'Publisher Donation Success' },
  { value: 'Publisher-NewMember', label: 'Publisher New Member' },
  { value: 'Publisher-NewSell-PageLink', label: 'Publisher New Sell Page link' },
  { value: 'Publisher-Payment-Integration-Error', label: 'Publisher Payment Integration Error' },
  { value: 'Publisher-Payment-Integration-Success', label: ' Publisher Payment Integration Success' },
  { value: 'Publisher-Withdraw-Error', label: 'Publisher Withdraw Error' },
  { value: 'Publisher-Withdraw-Request-Confirmation', label: 'Publisher Withdraw Request Confirmation' },
  { value: 'Publisher-Withdraw-Success', label: 'Publisher Withdraw Success' },
  { value: 'NFE-Update-Status', label: 'Update Status Nfe' },
  { value: 'Payment-Dispute-Status', label: 'Payment Dispute Status' },
  { value: 'User-Passwordless', label: 'User Passwordless' },
];